/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSlippage.vue?vue&type=template&id=3622dfd6"
import script from "./popSlippage.vue?vue&type=script&lang=js"
export * from "./popSlippage.vue?vue&type=script&lang=js"
import style0 from "./popSlippage.vue?vue&type=style&index=0&id=3622dfd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports